// Google Consent Mode v2 helpers

export const CONSENT_STORAGE_KEY = "zr_cookie_consent_v2";

export const DEFAULT_DENIED = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "granted",
  personalization_storage: "denied",
  security_storage: "granted",
};

export const ALL_GRANTED = {
  ad_storage: "granted",
  ad_user_data: "granted",
  ad_personalization: "granted",
  analytics_storage: "granted",
  functionality_storage: "granted",
  personalization_storage: "granted",
  security_storage: "granted",
};

export function readStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function writeStoredConsent(consent) {
  try {
    localStorage.setItem(
      CONSENT_STORAGE_KEY,
      JSON.stringify({ ...consent, updatedAt: new Date().toISOString() }),
    );
  } catch (_) {
    /* noop */
  }
}

function ensureGtag() {
  if (typeof window === "undefined") return () => {};
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
  }
  return window.gtag;
}

export function updateConsent(consent) {
  const gtag = ensureGtag();
  try {
    gtag("consent", "update", {
      ad_storage: consent.ad_storage,
      ad_user_data: consent.ad_user_data,
      ad_personalization: consent.ad_personalization,
      analytics_storage: consent.analytics_storage,
      functionality_storage: consent.functionality_storage || "granted",
      personalization_storage: consent.personalization_storage || "denied",
      security_storage: consent.security_storage || "granted",
    });
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "cookie_consent_update" });
    }
  } catch (_) {
    /* noop */
  }
}

export function applyStoredConsentOnLoad() {
  const stored = readStoredConsent();
  if (stored) {
    updateConsent(stored);
  }
  return stored;
}

export function buildConsentFromCategories({ analytics, ads, personalization }) {
  return {
    ad_storage: ads ? "granted" : "denied",
    ad_user_data: ads ? "granted" : "denied",
    ad_personalization: ads ? "granted" : "denied",
    analytics_storage: analytics ? "granted" : "denied",
    functionality_storage: "granted",
    personalization_storage: personalization ? "granted" : "denied",
    security_storage: "granted",
  };
}

export function acceptAll() {
  const consent = { ...ALL_GRANTED };
  writeStoredConsent(consent);
  updateConsent(consent);
  return consent;
}

export function rejectAll() {
  const consent = { ...DEFAULT_DENIED };
  writeStoredConsent(consent);
  updateConsent(consent);
  return consent;
}
